import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { RelatedContentCard } from '../related-content-card';
import {
	block as blockStyle,
	image as imageStyle,
	readOn as readOnStyle,
} from './style.module.css';
interface RelatedContentBlockProps {
	maxItems?: number;
	links?: Array<Queries.ArticleFragmentForLinkCardFragment>;
	tags?: string[];
}

export const search = (tags: string[], maxResults = 5) => {
	const data = useStaticQuery(graphql`
		query SearchResults {
			articles: allContentfulArticle(
				sort: { date: ASC }
				filter: { tags: { elemMatch: { name: { ne: null } } } }
			) {
				nodes {
					...ArticleFragmentForLinkCard
				}
			}
		}
	`);
	const unfilteredResults: Array<Queries.ArticleFragmentForLinkCardFragment> = data.articles.nodes;

	const filteredResults = unfilteredResults.filter((article) => {
		if (article.tags) {
			const articleTags = article.tags.flatMap((item) =>
				item ? (item.name ? item.name : []) : []
			);
			return tags.every((searchTag) => articleTags.includes(searchTag));
		}
	});

	return filteredResults;
};

export const RelatedContentBlock = ({
	maxItems = 5,
	links,
	tags,
}: RelatedContentBlockProps): JSX.Element => {
	const linkCount = links?.length ?? 0;
	const items = links ?? [];
	if (linkCount < maxItems) {
		const articles = tags ? search(tags, maxItems - linkCount) : [];
		while (items.length < maxItems && articles.length) {
			const relatedArticle = articles.pop();
			if (!relatedArticle || !relatedArticle.slug) continue;
			// is it already added?
			if (
				items.some(
					(page: Queries.ArticleFragmentForLinkCardFragment) => page.id === relatedArticle.id
				)
			)
				continue;
			// is it the current page?
			// TODO come back to this - location is not supported during build
			const slug = `/${relatedArticle.slug}`;
			items.push({ ...relatedArticle, slug });
		}
	}
	return (
		<div className={blockStyle}>
			<div className={readOnStyle}>Related Articles</div>
			{items.map((item) => {
				const { title, slug, summary, image } = item;
				return (
					title &&
					summary?.summary &&
					slug && (
						<RelatedContentCard
							href={slug}
							title={title}
							summary={summary.summary}
							linkLabel="Read more"
							renderImage={() => (
								<div className={imageStyle}>
									{!!image && !!image.url && (
										<img src={image.url} alt={image.title ?? ''} width="100%" />
									)}
								</div>
							)}
						/>
					)
				);
			})}
		</div>
	);
};
